import React from 'react';
import styled from 'styled-components';
import {
  SectionContainer,
  SectionTextContainer,
} from '../../../aboutUs/styles';
import { COLORS, device } from '../../../../constants';
import { Box, Title, VerticalBox } from '../../../../components';
import { TeamElement } from './TeamElement';
import { MotionYOffsetBlock } from '../../../../components/Motion';

interface Team {
  ProjectRole: string;
  CountOfMembers: number;
}
interface DivProps extends React.HTMLProps<HTMLDivElement> {
  team: Team[];
}

export const ProjectTeam: React.FC<DivProps> = ({ team, ...props }) => {
  if (team?.length === 0) return null;
  return (
    <SectionContainer $color={COLORS.LIGHT_BG_COLOR}>
      <Box>
        <VerticalBox>
          <SectionTextContainer $gap={80}>
            <Title title="Team" isAnimated={true} />
            <TeamContainer {...props}>
              {team.map(item => (
                <TeamElement
                  key={item.ProjectRole}
                  teamText={item.ProjectRole}
                  teamNr={item.CountOfMembers.toString()}
                />
              ))}
            </TeamContainer>
          </SectionTextContainer>
        </VerticalBox>
      </Box>
    </SectionContainer>
  );
};

const TeamContainer = styled(MotionYOffsetBlock)`
  background-color: ${COLORS.GRAY_BG_COLOR};
  display: flex;
  padding: 80px 0;
  width: 100%;
  box-sizing: border-box;
  justify-content: center;
  gap: 0;
  @media screen and (${device.md}) {
    padding: 40px;
  }
  @media screen and (${device.sm}) {
    padding: 20px;
  }
  @media screen and (${device.md}) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
`;
